export default "__VITE_ASSET__66b95422__"